import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    page:1,
    olddata:[]
   
    
}

const mutations={


    addStock(state,value){
       
        post(urls.admin.product_stock.index,value).then((result)=>{


            state.result= result
            
          
         
             
          });
    },

   
   
   
}
const  actions={
    addStockAction(context,value){
        
        context.commit("addStock",value)
       
    },

   
    
   
  
    
  
    
   

}

export default {state,mutations,actions}